












import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";



@Component
export default class BaseTLInfoPanel extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) isErrorPanel?: boolean; //error červená barva, jinak info
	@Prop({ type: Boolean, required: false, default: false }) isInfoPanel?: boolean; //error červená barva, jinak info
	@Prop({ type: Number, required: false, default: 2 }) minRow?: number; //velikost minimalní
	@Prop({ type: Number, required: false, default: 0 }) maxRow?: number; //velikost maximalni - pak nefunguje vlastnot moznost si to zvetsi jak chces
	@Prop({ required: true }) itemData: any; //data která chceme zobarzit vzor co dodat je data

	//načtení stylu
	get inputClass() {
		return {
			"info-panel-error": this.isErrorPanel == true,
			"info-panel-normal": this.isInfoPanel == true
		};
	}

	//vzor takhle to dodat
	data = "sd\nf\nsfdl sdfsdfds \n sd sdf sdfsd \n sdfsfd sdfsdf sdf sdfsfdl sdfsdfds sd sdf sdfsd sdfsfd sdfsd sdf sdfsd sdfsfd sdfsdf sdf sdf sdfsfdl sdfsdfds sd sdf sdfsd sdfsfd sdfsdf sdf";

}
